var listItems = {
	namespaced: true,
	state: {
		items: [],
		params: {
			pageYOffset: 0,
			results: 0,
			lastElement: null,
			limit: 0
		},
		orderColumns: {
			items: [],
			column: null,
			refreshFunction: () => {}
		},
		searching: {
			field: null,
			text: null,
			local: false,
			searchFunction: () => {},
		},
		viewList : {
			rowing: false,
			key: 0
		}
	},
	getters: {
		getItems(state) {
			return state.items
		},
		getOrderItems(state) {
			return state.orderColumns.items
		},
		getParams(state) {
			return state.params
		}
	},
	mutations: {
		toggleViewList(state){
			state.viewList.rowing = !state.viewList.rowing
			state.viewList.key == 0 ? state.viewList.key += 1 : state.viewList.key = 0			
		},
		setSearching(state, payload) {
			state.searching = {...state.searching, ...payload}
		},
		cleanSearching(state) {
			state.searching = {
				field: null,
				text: '',
				searchFunction: () => {}
			}
		},
		setOrderColumns(state, payload) {
			if (payload.reset) {
				if (!payload.data) {
					state.orderColumns = {
						items: [],
						column: null,
						refreshFunction: () => {}
					}
				} else {
					state.orderColumns = {
						items: payload.data.items,
						column: payload.data.column,
						refreshFunction: payload.data.refreshFunction ? payload.data.refreshFunction : state.orderColumns.refreshFunction
					}
				}
			} else {
				state.orderColumns = {...state.orderColumns, ...payload.data}
			}
		},
		setItems(state, payload) {
			if (payload.refresh == true) {
				state.items = payload.data
			} else {
				state.items = [...state.items, ...payload.data]
			}
		},
		setParams(state, payload) {
			state.params = { ...state.params, ...payload}
		},
		setParamsLastElement(state, payload) {
			payload ? state.params.lastElement = payload : state.params.lastElement = null
		},
		resetParams(state, payload) {
			state.params = {
				pageYOffset: 0,
				results: payload.results,
				lastElement: null,
				limit: payload.limit
			}
		}
	},
	actions: {
		changeOrder({state, commit}, payload) {
			var column = null
			var newItems = state.orderColumns.items.map((e, i) => {
				var n = e
				if (payload.index >= 0 || payload.id) {
					if (i == payload.index || e.id == payload.id) {
						n = {...e,...{order: e.order == 'asc' ? e.order = 'desc' : e.order = 'asc', selected: true}}
						column = n
					} else {
						n = {...e, ...{order: 'desc', selected:false}}
					}
				}
				return n
			})
			commit('setOrderColumns', {reset: true, data: {items: newItems, column: column}})
			if (state.searching.local) {
				state.items.sort((a, b) => {
					// TODO: Habria que hacer una funcion con switch para tipos de datos | string, fecha y si hay mas mas.
					// var newA = typeof a[column.id] == 'string' ? a[column.id].toUpperCase() : a[column.id]
					// var newB = typeof b[column.id] == 'string' ? b[column.id].toUpperCase() : b[column.id]
					var newA = a[column.id]
					var newB = b[column.id]

					if ( newA > newB ) {
						return column.order == 'asc' ? 1 : -1
					}
					if ( newA < newB ) {
						return column.order == 'asc' ? -1 : 1
					}
					return 0
				})
			}
		},
		resetLimits({commit}, payload) {
			commit('setParams', {...payload, ...{pageYOffset: 0}})
			commit('setParamsLastElement')
		},
		addResults({state, commit}, payload) {
			
			if (((window.innerHeight + window.scrollY) >= document.body.offsetHeight) && (document.body.offsetHeight > state.params.pageYOffset) && (state.params.lastElement || state.searching.local)) {
				var newParams = {
				pageYOffset: document.body.offsetHeight,
				results: state.params.results + state.params.limit
			}
				commit('setParams', newParams)
				if (state.searching.local == false){
					payload.functionToAdd()
				}
			}
		}
	}
}

export default listItems
